// @ts-strict-ignore
import { Component, EventEmitter, forwardRef, Input, Output, ViewChild } from '@angular/core';
import { LMDetailSectionBase } from './lm-detail-section-base';
import { LMFormTransactionEvent } from '@form/lm-form.component';
import { Observable, Observer, of } from 'rxjs';
import { LMUrlInfoBuilderService } from '@services/lm-url-info-builder.service';
import { LMRefreshRequest } from "@app/components";

@Component({
  selector: 'lm-detail-section-form',
  template:
  `<lm-form
          *ngIf="activated && fromDataView"
          [formUrlInfo]="formUrlInfo"
          [formSpec]="formSpec"
          [fromDataView]="fromDataView"
          (formDisplayed)="onFormDisplayed($event)"
          (formTransactionEvent)="onFormTransactionEvent($event)"
          (drillAroundEvent)="onDrillAroundEvent($event)"
      ></lm-form>`
  })
export class LMDetailSectionFormComponent implements LMDetailSectionBase {
  @ViewChild(forwardRef(() => 'lmFormComponent')) lmFormComponent; // : LMFormComponent;

  @Input() set formSpec(formSpec: LMFormSpec) {
    this._formSpec = formSpec;
    // todo: set this value on the server.
    this._formSpec.isReadOnly = true;
    this.formUrlInfo = this.lmUrlInfoBuilderService.getFormUrlInfoFromFormSpec(formSpec);
  }

  @Input() set fromDataView(fromDataView: LMDataView) {
    this._fromDataView = fromDataView;
  }

  @Input() needsReload: boolean;

  @Input() set activated(activated: boolean) {
    this._activated = activated;
  }

  @Output() detailSectionDisplayed = new EventEmitter<any>();
  @Output() panelDataUpdated = new EventEmitter<any>();
  @Output() drillAroundEvent = new EventEmitter<LMDrillAroundEvent>();

  private _activated;
  // todo: can remove once readOnly is placed into the formSpec on the server.
  private _formSpec: LMFormSpec = null;
  private _fromDataView: LMDataView = null;

  public formUrlInfo: LMFormUrlInfo;

  constructor(
    private lmUrlInfoBuilderService: LMUrlInfoBuilderService
  ) {}

  get activated() {
    return this._activated;
  }

  get fromDataView(): LMDataView {
    if (this.needsReload) {
      return null;
    }
    return this._fromDataView;
  }

  onFormDisplayed(formComponent: any) {
    this.detailSectionDisplayed.emit(this);
  }

  onFormTransactionEvent(event: LMFormTransactionEvent) {
    this.panelDataUpdated.emit(event);
  }

  onDrillAroundEvent(event: LMDrillAroundEvent) {
    this.drillAroundEvent.emit(event);
  }

  get formSpec(): LMFormSpec {
    return this._formSpec;
  }

  get type() {
    return 'standardform';
  }

  isModified(): boolean {
    return false;
  }

  saveDetailSectionState() {        // TODO:  Doesn't make sense to have a state on a detail section form
    if (this.lmFormComponent) {
      this.lmFormComponent.saveComponentState(true);
    }
  }

  clearDetailSectionState() {     // TODO:  Doesn't make sense to have a state on a detail section form
    if (this.lmFormComponent) {
      this.lmFormComponent.clearComponentState(true);
    }
  }

  save(callBack: Observer<boolean>) {
    // nothing to save
    callBack.next(true);
    callBack.complete();
  }

  public refresh(request: LMRefreshRequest): Observable<boolean> {
    return new Observable<boolean>(observer => {
      if (this.lmFormComponent) {
        this.lmFormComponent.runRefresh(observer);
      } else {
        observer.next(true);
        observer.complete();
      }
    });
  }
}
